import React, { useEffect } from 'react';
import { ColumnChartComponent } from '../../../../components/charts/ColumnChartComponent';
import { StackedBarChartComponent } from '../../../../components/charts/StackedBarChartComponent';
import { CardComponent } from '../../CardComponent';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { ActionsComponent } from './actionsComponent';
import {
  selectChangeSeriesButtonText,
  selectChartCategories,
  selectDistributionAPIResponse,
  selectDistributionChartData,
  selectDistributionComponentState,
  selectDistributionFirstLoadFulfilled,
  selectDistributionHasError,
  selectDistributionLabel,
  selectIsDistributionDataLoading,
  setChartData,
  setHTMLSubtitle,
  toggleChangeSeriesButton
} from './distributionComponentSlice';

export function DistributionComponent() {
  const componentState = useAppSelector(selectDistributionComponentState);
  const apiResponse = useAppSelector(selectDistributionAPIResponse);
  const factor = apiResponse.factor;
  const isDistributionLoading = useAppSelector(selectIsDistributionDataLoading);
  const distributionHasError = useAppSelector(selectDistributionHasError);
  const distributionLabel = useAppSelector(selectDistributionLabel);
  const customer = useAppSelector(selectDistributionLabel);
  const chartData = useAppSelector(selectDistributionChartData);
  const chartCategories = useAppSelector(selectChartCategories);
  const changeSeriesButtonText = useAppSelector(selectChangeSeriesButtonText);
  const distributionHasData = useAppSelector(selectDistributionFirstLoadFulfilled);
  const statisticString = componentState.statisticLabel;
  const visualization = apiResponse.visualization

  const clickHandler = {
    events: {
      click: (event) => {
        const point = event.point;
        /**
         * setStatistic function is defined in
         * website/js/pages/drilldown.js
         */
        // @ts-ignore
        setStatistic(point.filter, point.filterLabel);
      }
    }
  }
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setHTMLSubtitle());
    dispatch(setChartData());
  }, [apiResponse]);

  useEffect(() => {
    dispatch(setChartData())
  }, [changeSeriesButtonText]);

  return (
    <CardComponent
      title={`${distributionLabel} Distribution`}
      isLoading={isDistributionLoading}
      hasError={distributionHasError}
      actions={
        <ActionsComponent
          showFullDetailLink={componentState.apiResponse.visualization === 'bar'}
          changeSeriesClickHandler={() => dispatch(toggleChangeSeriesButton())}
          actions={changeSeriesButtonText}
          redirectClickHandler={() => {
            /**
             * satisfactionDrill function is defined in
             * website/js/pages/drilldown.js
             */
            // @ts-ignore
            // satisfactionDrill('', 'coachingoverview');
            satisfactionDrill('drilldown', 'coachingoverview');
          }}
          statisticString={statisticString}
        />
      }
    >
      {(!isDistributionLoading || distributionHasData) &&
        renderChart(
          visualization,
          customer,
          chartCategories,
          chartData,
          componentState,
          clickHandler,
          factor
        )}
    </CardComponent>
  );
}

const renderChart = (visualization, customer, chartCategories, chartData, componentState, clickHandler, factor) => {
  const { chartHTMLSubtitle, htmlSubtitle, columnChartDataPoints } = componentState;
  if (visualization === 'bar') {
    return (
      <StackedBarChartComponent
        title={`${customer} Distribution`}
        categories={chartCategories}
        dataPoints={chartData}
        htmlSubtitle={chartHTMLSubtitle}
        click={clickHandler}
      />
    );
  } else {
    return (
      <ColumnChartComponent
        categories={chartCategories}
        dataPoints={columnChartDataPoints}
        // dataPoints={[6, 8, 13, 3, 6, 4, 7, 4, 63]}
        htmlSubtitle={htmlSubtitle}
        name={''}
        title={htmlSubtitle}
        noDataMessage={'There is no data for the selected criteria'}
        factor={factor}
      />
    );
  }
}
